<template>
  <div class="m-page">
    <div class="padding appointmentReminders m-box">
      <span class="assertive">【温馨提醒】</span>快速预约，是预约体检名额，需<span class="assertive">体检当日前往体检中心</span>确认体检方案；<span class="positive" @click="toCenter">点击此处<i class="icon icon-arrow-right" style="font-size: 15px !important;"></i></span> 提前确认体检项目，快人一步
    </div>
    <div class="m-box">
      <v-radio v-model="self" :radioList="isSelfData" label="体检者" class="isSelf">
      </v-radio>
    </div>
    <div class="m-box">
      <v-input v-model="present.callName" placeholder="请输入姓名" label="姓　名" id="callName"></v-input>
      <v-input v-model="present.identityCardNo" :placeholder="present.initIdentityCardNo || '请输入正确的身份证号'" label="身份证"
               :maxlength="18" id="identityCardNo"></v-input>
      <v-input v-model="present.boCellPhoneNo" :placeholder="present.initBoCellPhoneNo || '请输入正确的手机号'" label="手机号" id="boCellPhoneNo"></v-input>
      <v-radio v-model="present.sexCode" :radioList="sexData" label="性　别" id="sexCode"></v-radio>
      <v-input v-model="present.age" placeholder="请输入年龄" label="年　龄" unit="岁" id="age"></v-input>
      <v-actionsheet v-model="present.marryStateCode" label="婚　姻" placeholder="请选择您的婚姻状况"
                     :dataList="actions"></v-actionsheet>
      <v-actionsheet v-model="present.folkId" label="民　族" placeholder="请选择您的民族" :dataList="folk"></v-actionsheet>
    </div>
    <div class="m-box">
      <v-input label="体检日期" v-model="present.boExaminationDate" id="boExaminationDate"  placeholder="请选择体检日期" disabledIcon="icon-rili1" :disabled="true" @click.native="showDatePicker" class="hasDateIcon"></v-input>
      <v-div v-model="sysCenterName" @clicked="changeSysCenter" :arrow="false" label="体检中心" placeholder="请选择体检中心">
      </v-div>
    </div>

    <m-button @click.native="submitOrder()" class="submitBtn">提交预约单</m-button>
    <hint :showModal="showHint" :showTxt="hintMsg.title" :btnList="hintMsg.btn" @btnClick="hanlder"></hint>
    <sys-center-list mode="projectSelectOpt" :hasRouter="false" :showModal.sync="showPopup"
                     @maskClick="closeSysCenterList" @itemClick="itemClick"></sys-center-list>
    <date-picker ref="datePicker" v-if="sysCenterId!=='00-7'" v-model="dateState" :dateList="dateList"
                 @getTime="getTime"
                 @specialHandler="specialHandler"></date-picker>
    <date-picker-time v-else-if="sysCenterId==='00-7'" ref="datePickerTime" v-model="dateState" :dateList="dateList"
                      :dateTimeList="dateTimeList"
                      @getTime="getTime" @selectDate="selectDate"></date-picker-time>
    <hint :showModal="hintShow" showTxt="当前处于新型冠状病毒肺炎特殊阶段，为保证您和他人的健康和安全，请先完成“新型冠状病毒流行病学史问卷调查”，再做下一步的体检预约！" :btnList="['在线评估']"
          @btnClick="surveyClick"></hint>
    <hint :showModal="hintShow007" showTxt="非常报歉根据问卷结果，您暂时无法预约体检。如有疑问请拨打中心电话咨询：<a class='positive' href='tel:025-68303350'>025-68303350</ a>"  :btnList="[]"></hint>
  </div>

</template>

<script>
import MButton from '../../components/common/button/m-button'
import jumper from '@/assets/scripts/jumper'
import Dict from '../../assets/scripts/dict/dict'
import {
  GET_USER,
  UPDATE_USER,
  BEFORE_QUESTION,
  BASE_PROJECT_LIST,
  VALIDATE_ORDER,
  SYSTEM_CENTER_APPOINTMENT_CONFIG,
  TEST_DATE_BY_PROJECT,
  GET_LIMIT_NUM_FOR_DATE_007
} from '@/assets/scripts/api'
import axios from 'axios'
import Vue from 'vue'
import { VRadio, VInput, VActionsheet, hint, sysCenterList, VDiv } from '@/components/common'
import { mapGetters, mapState } from 'vuex'
import { Loading, ToastMessage, IDCardMsg } from '@/assets/scripts/helper'
import validation from '@/assets/scripts/validation'
import DatePicker from '@/components/common/date/date-picker'
import DatePickerTime from '@/components/common/date/date-picker-time'
import router from "../../router/router";

Vue.use(validation)

export default {
  components: {MButton, Loading, VRadio, VInput, VActionsheet, hint, sysCenterList, VDiv, DatePickerTime, DatePicker},
  data () {
    return {
      hintShow007: false,
      hintShow: false, // 新冠新加提示
      dateState: false, // 日历显示
      dateList: [], // 日期集合
      dateTimeList: [], // 当日时间段
      showPopup: false, //中心选择弹出插件相关
      projectSelectOpt: true, //中心选择弹出插件相关
      showHint: false, //原有提示（可以和新冠合并，考虑后期不需要新冠。暂时分开）
      hintMsg: {title: '', btn: []}, //原有提示的配置
      msgList: { //原有提示的配置
        orderErr: {title: '', btn: ['查看订单', '确定'], name: 'order'},
        showConfig: {title: '该体检中心暂未开放自选项目预约，是否继续选择其他体检中心预约', btn: ['查看套餐', '确定'], name: 'config'}
      },

      folk: Dict.user_folk, // 民族
      sexData: [
        {name: '男', code: 'male'},
        {name: '女', code: 'female'}
      ],
      actions: [
        {name: '已婚(含同居)', id: 'married'},
        {name: '未婚', id: 'unmarried'}
      ],
      self: '1', // 1 自己 0其他人
      othersData: {}, // 保存代他人数据
      selfData: {}, // 保存自己数据
      present: {
        boExaminationDate: '', //日期
        boExaminationTime: '',
        boExaminationNo: '',
        callName: '',
        marryStateCode: '',
        identityCardNo: '',
        initIdentityCardNo: '',
        boCellPhoneNo: '',
        initBoCellPhoneNo: '',
        sexCode: '',
        age: '',
        folkId: ''
      }
    }
  },
  validation: {
    data: {
      'present.callName': {
        required: true,
        RegExp: '^([\\u4e00-\\u9fa5]{2,10}|[a-zA-Z]{2,10})$|^(?=.*[\\u4e00-\\u9fa5])(?=.*\\d)[\\u4e00-\\u9fa5\\d]{2,10}$'
      },

      'present.identityCardNo': {
        if: function (dataValidations) {
          if ((this.self === '1' && this.present.initIdentityCardNo === '') || this.self === '0') {
            dataValidations.required = true
          } else if (dataValidations.required) {
            dataValidations.required = false
          }
        },
        IDCard: true,
        RegExp: '^([1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx])$|^([1−9]\\d5\\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\\d2[0−9Xx])$'
      },
      'present.boCellPhoneNo': {
        if: function (dataValidations) {
          if ((this.self === '1' && this.present.initBoCellPhoneNo === '') || this.self === '0') {
            dataValidations.required = true
          } else if (dataValidations.required) {
            dataValidations.required = false
          }
        },
        RegExp: '^[1][0-9]{10}$'
      },
      'present.sexCode': {
        required: true
      },
      'present.age': {
        required: true,
        between: {
          min: 12,
          max: 85
        }
      },
      'present.marryStateCode': {
        required: true
      },
      'present.folkId': {
        required: true
      },
      'present.boExaminationDate': {
        required: true
      }

    },
    msg: {
      'present.callName': {
        required: '请输入体检者姓名',
        RegExp: '必须为全中文或全英文'
      },
      'present.age': {
        between: '年龄必须在12-85范围内！'
      }

    }
  },
  async created () {
    Loading.show()
    let han = this.folk[0]
    let folkObj = {folkId: han.id, folkName: han.name, folkCode: han.code}
    this.othersData = Object.assign({}, this.present, folkObj)
    let {data} = await this.$axios.get(GET_USER)
    this.selfData = Object.assign({}, this.present, data.data)
    //处理数据展示
    if (/^[0-9]+$/.test(this.selfData.callName)) {
      this.selfData.callName = ''
    }
    if (!this.selfData.folkId || !this.selfData.folkName || !this.selfData.folkCode) {
      Object.assign(this.selfData, folkObj)
    }
    let {callName, idCardNo, code} = this.selfData
    this.selfData.initName = callName
    this.selfData.initIdentityCardNo = idCardNo
    this.selfData.identityCardNo = ''
    this.selfData.initBoCellPhoneNo = code
    this.selfData.boCellPhoneNo = ''

    this.present = Object.assign({}, this.selfData)
    if (Object.keys(this.fillUserInfo).length > 0) {
      this.self = this.fillUserInfo.self || this.fillUserInfo.isSelf || '1'
      Object.assign(this.othersData, this.fillUserInfo)
    }

    if (this.$route.query.survey) {
      if(this.$route.query.sid === '00-7' && data.data && data.data.isGzbd === '1'){
        this.hintShow007 = true
      }else {
        this.hintShow = true
      }

    }
    await this.loadTestDate()
    this.$nextTick(() => {
      this.$validation.reset()
    })
    Loading.close()
  },
  methods: {
    toCenter () {
      this.$router.push({name: 'entrance', query: {sid: this.sysCenterId}})
    },
    showDatePicker () {
      this.dateState = true
    },
    async specialHandler () {
      Loading.show()
      await this.loadTestDate()
      Loading.close()
    },
    getTime (item) {
      console.log(item)
      this.present.boExaminationDate = item.date
      this.present.boExaminationTime = item.time
      this.present.boExaminationTimeNo = item.id
    },
    async loadLimitNumForData007 (date) {
      Loading.show()
      let {data} = await this.$axios.get(GET_LIMIT_NUM_FOR_DATE_007, {
        params: {
          date: date
        }
      })
      Loading.close()
      return data
    },
    async selectDate (date) {
      let dateInfo = await this.loadLimitNumForData007(date.replace(/-/g, ''))
      this.dateTimeList = dateInfo.dateHasPeopleList || []
    },
    surveyClick () {
      if(this.$route.query.sid === '00-7'){
        this.$router.replace({name: 'diseaseIndex', query: {id: '00-7', source: '4'}})
      }else
        this.$router.replace({name: 'diseaseIndex', query: {id: '24', source: '4'}})
    },
    async loadTestDate () {
      if (!this.sysCenterId || this.sysCenterId === '00-0') {
        return
      }
      let params = {
        sysCenterId: this.sysCenterId,
        proIds: ''
      }
      if (this.sysCenterId === '00-7') {
        let {data} = await this.$axios.get('/order/getDateRange.json', {params: params})
        let dateList = []
        if (data.beginDay && data.endDay) {
          var beginDay = new Date(data.beginDay)
          var endDay = new Date(data.endDay)
          while ((endDay.getTime() - beginDay.getTime()) >= 0) {
            var year = beginDay.getFullYear()
            var month = beginDay.getMonth().toString().length == 1 ? '0' + (beginDay.getMonth() + 1).toString() : beginDay.getMonth() + 1
            var day = beginDay.getDate().toString().length == 1 ? '0' + beginDay.getDate() : beginDay.getDate()
            dateList.push({
              code: '000',
              desc: '当前日期可以预约',
              testDate: year + '-' + month + '-' + day
            })
            beginDay.setDate(beginDay.getDate() + 1)
          }
        }
        this.dateList = dateList
      } else {
        let {data} = await this.$axios.get(TEST_DATE_BY_PROJECT, {params: params})
        let $this = this
        this.dateList = data.map(date => {
          date.specialProDtos = date.specialProDtos.map(specialProject => {
            let project = $this.$store.state.project.checkedProjectList.find(p => p.id === specialProject.projectId)
            if (project) {
              specialProject.base = project.base
              specialProject.delectable = project.delectable
            }
            if (specialProject.delectable === '0') {
              date.code = specialProject.code
            }
            return specialProject
          })

          return date
        })
      }
    },
    async itemClick (e) {
      let {data} = await this.$axios.get(SYSTEM_CENTER_APPOINTMENT_CONFIG, {
        params: {
          sysCenterId: e.id,
          _BIZCODE: '0001'
        }
      })
      if (data.projectSelectOpt === 0 && this.$route.params.source === 'custom') {
        this.projectSelectOpt = false
        this.hintMsg = this.msgList.showConfig
        this.showHint = true
      } else {
        this.projectSelectOpt = true
      }
    },
    async toCustomAppointmentConfirm () {
      Loading.show()
      await this.$store.dispatch('project/loadProjectData', {
        sexCode: this.present.sexCode,
        marryStateCode: this.present.marryStateCode,
        age: this.present.age,
        sysCenterId: this.$store.state.center.sysCenter.id,
        aqInstanceId: ''
      })
      let {data} = await axios.get(BASE_PROJECT_LIST({
        sexCode: this.present.sexCode,
        marryStateCode: this.present.marryStateCode,
        age: this.present.age,
        sysCenterId: this.$store.state.center.sysCenter.id
      }))
      let basePackagePros = data.map(project => {
        project.projectId = project.id
        return project
      })
      this.$store.commit('project/initCustomizeProjectList', {
        basePackagePros,
        rulePackagePros: [],
        recommendPros: []
      })
      this.$store.commit('project/initProjectClassList')
      this.$store.commit('project/setCheckedMaterialProjectList')
      Loading.close()
    },
    async closeSysCenterList () {
      if (this.$store.state.sid === '00-0' && !this.$store.state.center.sysCenter.name) {
        ToastMessage('请先选择一个体检中心')
      } else {
        Loading.show()
        await this.loadTestDate()
        this.present.boExaminationDate = ''
        this.present.boExaminationTime = ''
        Loading.close()
        this.showPopup = false
      }
    },
    changeSysCenter () {
      this.showPopup = true
    },
    async setFillUserData () {
      let params = {isSelf: this.self}
      if (this.self === '0') {
        params.mobilePhone = ''
      }
      this.$store.commit('user/setFillUserInfo', Object.assign({}, this.present, params))
    },
    async submitOrder () {
      let errObj = this.$validation.validAll()
      if (!errObj) {
        Loading.show()
        let order = {
          age: this.present.age,
          autoBind: '0',
          boCellPhoneNo: this.present.boCellPhoneNo || this.present.initBoCellPhoneNo || '',
          boExaminationDate: this.present.boExaminationDate,
          boExaminationTime: this.present.boExaminationTime,
          boExaminationTimeNo: this.present.boExaminationTimeNo,
          name: this.present.callName,
          customIdList: [],
          discountPriceTotal: 0,
          price: 0,
          identityCardNo: this.present.identityCardNo || '',
          invoiceTitleType: '0',
          marryState: this.present.marryStateCode === 'married' ? '已婚（含同居）' : '未婚',
          marryStateCode: this.present.marryStateCode,
          materiaList: [],
          packages: [],
          recommendIdList: [],
          payType: 'onhospital',
          paymentType: 'onhospital',
          scope: 'paper',
          sexCode: this.present.sexCode,
          sexName: this.present.sexCode === 'male' ? '男' : '女',
          sysCenterId: this.sysCenterId,
          sysCenterName: this.sysCenterName,
          quickAppointment: 1,
          _BIZCODE: '0002'
        }
        if (await this.getValidate()) {
          let { data } = await this.$axios.post('/wx/2/appointment/order.json', order)
          if (data.data && data.data.orderId) {
            this.$router.replace({name: 'shortcutOrderSuccess', params: {sysCenterId: this.sysCenterId, id: data.data.orderId}, query: {type: '1'}})
          }
        }

        Loading.close()
      } else {
        let idIndex = 99
        let idList = ['callName', 'identityCardNo', 'boCellPhoneNo', 'sexCode', 'age', 'marryStateCode', 'folkId', 'boExaminationDate']
        for (var key in errObj) {
          var index = idList.findIndex(obj => { return key.split('.')[1] === obj })
          idIndex = index < idIndex ? index : idIndex
        }
        jumper.jump('#' + idList[idIndex])
      }
    },
    async updateUser () {
      Loading.show()
      this.present._BIZCODE = '0004'
      this.present.sexFromId = this.present.sexCode
      this.present.ageFromId = this.present.age
      if (this.present.birthday !== undefined) delete (this.present.birthday)
      await axios.post(UPDATE_USER, this.present)
      this.$store.dispatch('user/replaceUserData')
      Loading.close()
    },
    async getValidate () { //验证是否有已经预约过
      let data = await this.$axios.get(VALIDATE_ORDER, {
        params: {
          sysCenterId: this.sysCenterId,
          idCardNo: this.present.identityCardNo || ''
        }
      })
      let state = true
      if (data.error) {
        this.msgList.orderErr.title = data.error
        this.hintMsg = this.msgList.orderErr
        this.showHint = true
        state = false
      }
      return state
    },
    hanlder (index) {
      this.showHint = false
      if (index === 0) {
        if (this.hintMsg.name === 'config') {
          this.$router.push({name: 'productList', query: {sysCenterId: this.$store.state.center.sysCenter.id}})
        } else if (this.hintMsg.name === 'order') {
          this.$router.push({name: 'order', query: {type: '1'}})
        } else {
          this.$router.go(-2)
        }
      } else if (index !== 'mask' && this.hintMsg.name === 'config') {
        this.showPopup = true
      }
    }
  },
  computed: {
    sysCenterId () {
      return this.$store.state.project.product && this.$store.state.project.product.id ? this.$store.state.project.product.sysCenterId : this.$store.state.center.sysCenter.id
    },
    ...mapGetters({
      hasSysCenter: 'center/hasSysCenter'
    }),
    fillUserInfo () {
      return this.$store.state.user.fillUserInfo
    },
    ...mapState({
      sid: state => state.sid
    }),
    sysCenterName () {
      return this.$store.state.center.sysCenter.name || ''
    },
    isSelfData () {
      let name = '缺省'
      let selfData = this.selfData
      if (selfData && selfData.initName && selfData.initName.length >= 6) {
        name = selfData.initName.substring(0, 3) + '...' + selfData.initName.substring(selfData.initName.length - 2, selfData.initName.length)
      } else if (selfData.initName) {
        name = selfData.initName
      }
      return [{name: `自己 (${name})`, code: '1'}, {name: '代他人', code: '0'}]
    }
  },
  watch: {
    'present.identityCardNo' (newValue, oldValue) {
      this.$nextTick(obj => {
        if (newValue && !this.$validation.error('present.identityCardNo')) {
          let msg = IDCardMsg(this.present.identityCardNo)
          this.present.age = msg.age
          this.present.sexCode = msg.sexCode
        }
      })
    },
    self () {
      if (this.self === '1') {
        this.present = this.selfData
      } else {
        this.present = this.othersData
      }
      this.$nextTick(() => {
        this.$validation.reset()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
  .m-box {
    margin-bottom: 10px;
    background-color: #ffffff;
  }
  .m-page{
    padding-bottom: 80px;
  }
  .m-pop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: rgba(7, 17, 27, 0.7);
    .m-pop-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 313px;
      height: 290px;
      border-radius: 15px;
      font-size: 0;
      background-color: #ffffff;
      > img {
        width: 100%;
        height: 98px;
        border-radius: 15px 15px 0 0;
      }
      .m-pop-cont {
        position: relative;
        width: 100%;
        height: 140px;
        padding: 20px;
        text-align: center;
        .m-pop-img {
          position: absolute;
          top: -30%;
          left: 50%;
          width: 88px;
          height: 88px;
          transform: translateX(-50%);
        }
        h4 {
          font-weight: bold;
          line-height: 44px;
          font-size: 18px;
          color: #333333;
        }
        p {
          line-height: 24px;
          font-size: 14px;
          color: #666666;
        }
        .m-pop-title {
          line-height: 44px;
          padding: 30px 0 10px;
          font-size: 24px;
          font-weight: bold;
          color: rgb(242, 89, 48);
        }
        .m-pop-text {
          line-height: 24px;
          font-size: 14px;
          text-align: left;
          color: #666666;
        }
      }
      p {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        border-top: 1px solid #f5f5f5;
        color: #f25930;
      }
      .m-pop-foot {
        padding-top: 80px;
        text-align: center;
        .btn {
          height: 30px;
          line-height: 28px;
          padding: 0 24px;
          font-size: 14px;
          border-radius: 15px;
          &:first-child {
            margin-right: 20px;
            background-color: #ffffff;
            border: 1px solid rgb(242, 89, 48);
            color: rgb(242, 89, 48);
          }
          &:last-child {
            background-color: rgb(242, 89, 48);
            border: 1px solid rgb(242, 89, 48);
            color: #ffffff;
          }
        }
      }
    }
  }

  .agree {
    font-size: 14px;
    margin-top: 10px;
    padding: 0 15px;

  }

  .isSelf /deep/ .m-rads .m-rad:first-child {
    flex: 0 0 65% !important;
  }

  .centerName /deep/ {
    .item-right {
      flex: 0 0 65%;
      .m-sub {
        text-overflow: ellipsis;
        overflow: hidden;
        /*white-space: nowrap;*/
        width: 100%;
      }
    }
  }
  .hasDateIcon /deep/{
    input{
      color: #333;
    }
    input::placeholder {
      color: red;
    }
    input::-webkit-input-placeholder { /* WebKit browsers 适配谷歌 */
      color: red;
    }
    .icon-rili1{
      font-size: 25px;
    }
  }
  .appointmentReminders{
    /*position: fixed;*/
    /*top:0px;*/
    background: $light;
    line-height: 1.5;
    .text-red{
      font-weight: bold;
      color: red;
    }
  }
  .submitBtn{
    width: 90%;
    position: fixed;
    bottom: -10px;
  }
</style>
